<template>
  <div class="checkbox_group">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.checkbox_group .b-checkbox.checkbox {
  display: flex;
  margin-bottom: 8px;
}

.checkbox_group .b-checkbox.checkbox + .checkbox {
  margin-left: 0;
}
</style>
